import { Action, createReducer, on } from '@ngrx/store';

import * as VerifyUserActions from './verify-user.actions';

export const VERIFY_USER_FEATURE_KEY = 'verifyUser';

export interface VerifyUserState {
  verifying: boolean; // has the VerifyUser list been loaded
  error?: Error | null; // last known error (if any)
}

export interface VerifyUserPartialState {
  readonly [VERIFY_USER_FEATURE_KEY]: VerifyUserState;
}

export const initialVerifyUserState: VerifyUserState = {
  // set initial required properties
  verifying: false,
};

const reducer = createReducer(
  initialVerifyUserState,
  on(VerifyUserActions.verifyUser, (state) => ({
    ...state,
    verifying: true,
    error: null,
  })),
  on(VerifyUserActions.verifyUserSuccess, (state) => ({
    ...state,
    verifying: false,
  })),
  on(VerifyUserActions.verifyUserFailure, (state, { error }) => ({
    ...state,
    verifying: false,
    error,
  })),
);

export function verifyUserReducer(
  state: VerifyUserState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
